import Stack from "@mui/material/Stack"
import Typography from "@mui/material/Typography"

import AppIntroVideo from "@assets/app_intro_video"
import useTranslate from "@hooks/use_translate"

export default function Step1() {
  const { translate } = useTranslate()

  return (
    <Stack sx={{ alignItems: "center" }} gap={2} pb={2}>
      <AppIntroVideo />
      <Typography variant="h5" fontWeight={"bold"} textAlign={"center"}>
        {translate("public_layout_sign_in_demo")}
      </Typography>
      <Typography sx={{ color: "gray" }} textAlign={"center"}>
        {translate("public_layout_fill_form_text")}
        <br />
        {translate("public_layout_demo_info_text")}
      </Typography>
    </Stack>
  )
}
